import React from 'react';
import type { Course, BudgetResult, RecoveryPath } from '@abs/shared-types';
import { CourseCard } from './CourseCard';

export interface CourseCardGridProps {
  coursesWithBudget: Array<{ course: Course; budget: BudgetResult; recovery: RecoveryPath | null }>;
  onAddCourse: () => void;
}

export function CourseCardGrid({ coursesWithBudget, onAddCourse }: CourseCardGridProps): React.ReactElement {
  return (
    <div className="course-card-grid">
      {coursesWithBudget.map(({ course, budget, recovery }) => (
        <CourseCard key={course.id} course={course} budget={budget} recovery={recovery} />
      ))}
      <button className="course-card course-card--add" onClick={onAddCourse} type="button">
        <span className="course-card__add-icon" aria-hidden="true">+</span>
        <span className="course-card__add-label">Add Course</span>
      </button>
    </div>
  );
}
